<template>
  <div>
    <template v-if="isTouchDevice">
      Tippe auf ein Gerät um Dateien zu versenden.<br>
      Tippe lange auf ein Gerät um Nachrichten zu versenden.
    </template>
    <template v-else>
      Klicke auf ein Gerät um Dateien zu versenden.<br>
      Rechtsklick auf ein Gerät um Nachrichten zu versenden.
    </template>
  </div>
</template>

<script>
  import Vue from 'vue';
  import {switchRoom} from './step-utils';
  import {isTouchDevice} from '../../assets/js/utils';


  const component = {
    name: 'StepPeerSend',

    data: () => ({
      isTouchDevice
    })
  };


  export const StepPeerSend = {
    before: async () => {
      await switchRoom('local');
      Vue.store.commit('share/updateTour', {examplePeer: true});
    },
    after: () => Vue.store.commit('share/updateTour', {examplePeer: false}),
    target: '[peer-id="example"]',
    header: 'Dateien oder Nachrichten versenden',
    content: component
  };


  export default component;
</script>
